import React from "react"
import { Container } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import HelpTable from "./helpTable"

const HelpRequests = () => {
  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={"Help Requests"} />
          <HelpTable />
        </Container>
      </div>
    </>
  )
}

export default HelpRequests
